import {BoxProps} from "@mui/material"
import {FC} from "react"
import {makeStyles} from "tss-react/mui";
import type {IModuleScheduled} from "@buildwitt/shapeshift-types";
import {Link, useMatch} from "react-router-dom";
import {palette} from "@/constants";
import {MenuLessonCard} from "@/app2/pages/HomePage/Components/MenuLessonCard";
import {getVideoThumbnail} from "@/pages/HomePage/TodayLearningSection/utils";

interface IProps extends BoxProps {
	module: IModuleScheduled
}

const useStyles = makeStyles<{pageIsActive: boolean}>()((theme, {pageIsActive}) => ({
	trainingFeedModule: {
		outline: "1px solid " + (pageIsActive ? theme.palette.primary.main : palette.grey05)
	}
}));


export const TrainingFeedModuleSlim:FC<IProps> = ({className, module, ...boxProps}) => {
	const url = "/feed/" + module.course.slug + "/" + module.type + "/" + module.slug;
	const pageIsActive = useMatch(url);

	return (
		<Link to={url} style={{width: "100%"}}>
			<MenuLessonCard
					isActive={!!pageIsActive}
					title={module.title}
					duration={module.duration}
					imageUrl={getVideoThumbnail(module)}
					dueDate={module.dueDate}
					completed={module.complete}
					courseEnrollmentType={module.courseEnrollmentType}
					{...boxProps}
				/>
		</Link>
	)
}